import { api } from './client';

export interface DialogItem {
  id: string;
  source: 'ticket' | 'max';
  posted_at: string;
  author_name: string | null;
  author_email: string | null;
  body: string;
  is_internal: boolean;
  is_command: boolean;
  ticket_id: string | null;
  ticket_number: number | null;
  ticket_subject: string | null;
}

export interface DialogsQuery {
  ticket_id?: string;
  source?: 'ticket' | 'max' | 'all';
  include_internal?: boolean;
  include_commands?: boolean;
  limit?: number;
}

export const dialogsApi = {
  list: (orgId: string, q: DialogsQuery = {}) => {
    const params = new URLSearchParams();
    if (q.ticket_id) params.set('ticket_id', q.ticket_id);
    if (q.source) params.set('source', q.source);
    if (q.include_internal !== undefined) params.set('include_internal', String(q.include_internal));
    if (q.include_commands !== undefined) params.set('include_commands', String(q.include_commands));
    if (q.limit) params.set('limit', String(q.limit));
    return api.get<DialogItem[]>(`/api/v1/organizations/${orgId}/dialogs?${params.toString()}`).then(r => r.data);
  },
};
